import { Observable } from 'rxjs';
import { HttpContextToken } from '@angular/common/http';
import {
  APIRequestBodyModel,
  ContainerModel,
  ContainersResponseBody,
} from '@app/models/server/layout.model';
import { Params } from '@angular/router';

export const BYPASS_LOADER = new HttpContextToken(() => false);

export abstract class HttpClientService {
  abstract getDynamicContainersData(
    api: string,
    isCacheEnabled: boolean,
    key: string,
    apiRequestBody: APIRequestBodyModel,
    params: Params,
    skipLoader?: boolean,
  ): Observable<ContainerModel[] | ContainersResponseBody>;

  abstract getExternal(url: string, options: any): Observable<any>;

  abstract get(
    url: string,
    options: any,
    skipLoader?: boolean,
  ): Observable<any>;

  abstract put(url: string, body: any, options: any): Observable<any>;

  abstract post(
    url: string,
    body: any,
    options: any,
    skipLoader?: boolean,
  ): Observable<any>;

  abstract delete(url: string, options: any): Observable<any>;

  abstract getDynamicContainers(
    api: string,
    apiRequestBody: APIRequestBodyModel,
    params: Params,
    skipLoader: boolean,
  ): Observable<ContainerModel[] | ContainersResponseBody>;
}
